import { fontWeightNormal } from '@atlas-frontend/design-tokens';
import { FC, PropsWithChildren } from 'react';
import { Button, Flex } from 'antd';
import styled from 'styled-components';
import {
  CategoryFormDataType,
  getDatePeriodString,
  Modal,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  Padding,
} from '@atlas-frontend/sdk';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './CategoryRelationsModal.translations.json';

const { addTranslations, useTranslation } = i18nNsFactory(
  'category-relations-modal',
);
addTranslations(translations);

export interface CategoryRelationsModalProps extends PropsWithChildren {
  name: 'categories' | 'categoryGroups' | 'combinedGroups';
  categoryData: CategoryFormDataType;
  onClose: () => void;
}

export const CategoryRelationsModal: FC<CategoryRelationsModalProps> = (
  props,
) => {
  const { name, categoryData, onClose, children } = props;
  const { t } = useTranslation();

  return (
    <Modal
      footer={
        <ModalFooter>
          <Button
            id="close-category-relations-modal"
            type="primary"
            onClick={onClose}
          >
            {t('button.close')}
          </Button>
        </ModalFooter>
      }
      onCancel={onClose}
      width="70rem"
    >
      <ModalHeader>
        <TitlesWrapper justify="space-between">
          <ModalTitle>
            {t(`title.${name}`)}{' '}
            {`${categoryData.code} - ${categoryData.name} (${t(`entries`, {
              count: categoryData.categoryRelations.length,
            })})`}
          </ModalTitle>
          <SecondaryTitle>
            {getDatePeriodString(...categoryData.validPeriod)}
          </SecondaryTitle>
        </TitlesWrapper>
      </ModalHeader>
      <Padding
        scrollable
        left
        right
        bottom
        id="category-relations-modal-content"
      >
        <Padding top>{children}</Padding>
      </Padding>
    </Modal>
  );
};

const TitlesWrapper = styled(Flex)`
  padding-right: 30px;
`;

const SecondaryTitle = styled(ModalTitle)`
  font-weight: ${fontWeightNormal} !important;
`;
